import { LanguageSelector, RegionCheckerBar, RegionCurrent } from '@/modules/localization';

if (document.getElementById('LanguageSelector')) {
    new LanguageSelector(document.getElementById('LanguageSelector'));
}

if (document.querySelector('.js-region-checker-bar')) {
    new RegionCheckerBar(document.querySelector('.js-region-checker-bar'));
}

if (document.getElementById('RegionCurrent')) {
    new RegionCurrent(document.getElementById('RegionCurrent'));
}

